import { createFileRoute } from "@tanstack/react-router";
import ChangePasswordCard from "@/components/common/change-password-card";

export const Route = createFileRoute("/_protected/factory/change-password")({
  component: ChangePasswordComponent,
});

function ChangePasswordComponent() {
  return (
    <section className="flex justify-center items-center h-full">
      <ChangePasswordCard />
    </section>
  );
}
